import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type DropdownFixtureComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{},
	Record<string, never>
>;

export const dropdownEntryPoint: EntryPoint<DropdownFixtureComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-points/DropdownEntryPointFixture" */ './dropdown-ui.tsx'
			) as unknown as Promise<{ default: DropdownFixtureComponent }>, // I honestly don't get why this has to be done but it does
		{
			moduleId: 'dropdown-entrypoint',
		},
	),
	getPreloadProps: () => ({}),
});
